// Import React.
import React, { useState } from "react";



// Export the FAQ section.
export const FaqSection = ({
    sections = [],
}) => {

    // Track which FAQ sections have been expanded.
    const [expandedSections, setExpandedSections] = useState({});



    // Expand or collapse a FAQ section.
    const toggleSection = (sectionKey) => {

        setExpandedSections((currentSections) => ({
            ...currentSections,
            [sectionKey]: !currentSections[sectionKey],
        }));

    };



    // Return nothing when no FAQ sections have been supplied.
    if (!Array.isArray(sections) || sections.length === 0) { return null; }



    // Render the FAQ section.
    return (

        // Add the FAQ identifier used by the navigation button.
        <section
            className="landing-faq"
            id="faq"
            aria-labelledby="landing-faq-title"
        >

            {/* Constrain the FAQ content width. */}
            <div className="landing-faq__inner">

                {/* Render the FAQ heading. */}
                <h2
                    className="landing-faq__title"
                    id="landing-faq-title"
                >
                    Frequently Asked Questions
                </h2>

                {/* Render each FAQ section. */}
                <div className="landing-faq__sections">

                    {/* Loop through each supplied FAQ section. */}
                    {sections.map((section, sectionIndex) => {

                        // Prepare the section display state.
                        const sectionKey = section?.id ?? sectionIndex;
                        const sectionFaqs = Array.isArray(section?.faqs) ? section.faqs : [];
                        const sectionExpanded = expandedSections[sectionKey] === true;
                        const visibleFaqs = sectionExpanded ? sectionFaqs : sectionFaqs.slice(0, 3);
                        const hiddenFaqCount = sectionFaqs.length - 3;

                        // Render the section and its FAQs.
                        return (

                            <div
                                className="landing-faq__section"
                                key={sectionKey}
                            >

                                {/* Render the section heading. */}
                                <div className="landing-faq__section-heading">

                                    <h3 className="landing-faq__section-title">
                                        {section?.name}
                                    </h3>

                                    {/* Render the section description when one has been supplied. */}
                                    {section?.description && (
                                        <p className="landing-faq__section-description">
                                            {section.description}
                                        </p>
                                    )}

                                </div>

                                {/* Render the visible FAQ items. */}
                                <div className="landing-faq__items">

                                    {/* Loop through each visible FAQ in this section. */}
                                    {visibleFaqs.map((faq, faqIndex) => (

                                        // Render an expandable FAQ.
                                        <details
                                            className="landing-faq__item"
                                            key={faq?.id ?? faqIndex}
                                        >

                                            {/* Render the clickable question. */}
                                            <summary className="landing-faq__question">
                                                {faq?.question}
                                            </summary>

                                            {/* Render the trusted FAQ answer HTML. */}
                                            <div
                                                className="landing-faq__answer"
                                                dangerouslySetInnerHTML={{ __html: faq?.answer || "" }}
                                            />

                                        </details>

                                    ))}

                                </div>

                                {/* Allow sections with more than three FAQs to be expanded. */}
                                {hiddenFaqCount > 0 && (
                                    <button
                                        className="landing-faq__more"
                                        type="button"
                                        onClick={() => toggleSection(sectionKey)}
                                        aria-expanded={sectionExpanded}
                                    >
                                        {sectionExpanded ? "Show less" : `Show ${hiddenFaqCount} more`}
                                    </button>
                                )}

                            </div>

                        );

                    })}

                </div>

            </div>

        </section>

    );

};